import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
var Context = /*#__PURE__*/React.createContext();
export function useProductContext() {
  return useContext(Context);
}
export default function ProductContext(_ref) {
  var children = _ref.children,
      product = _ref.product,
      _ref$productIndex = _ref.productIndex,
      productIndex = _ref$productIndex === void 0 ? 0 : _ref$productIndex;
  var context = useMemo(() => {
    var _product$imageSets$de, _product$imageSets$de2, _product$imageSets$pl, _product$imageSets$pl2;

    // TODO: Watch out of other times we need to do backwards compatibility stuff like this in context,
    // it might be better to do this a level higher (e.g. Apollo Cache?)
    var productImages = product.imageSets ? {
      default: (_product$imageSets$de = (_product$imageSets$de2 = product.imageSets.default) === null || _product$imageSets$de2 === void 0 ? void 0 : _product$imageSets$de2.images) !== null && _product$imageSets$de !== void 0 ? _product$imageSets$de : null,
      plus: (_product$imageSets$pl = (_product$imageSets$pl2 = product.imageSets.plus) === null || _product$imageSets$pl2 === void 0 ? void 0 : _product$imageSets$pl2.images) !== null && _product$imageSets$pl !== void 0 ? _product$imageSets$pl : null
    } : product.productImages;
    return _objectSpread(_objectSpread({}, product), {}, {
      productIndex: String(productIndex),
      productImages
    });
  }, [product, productIndex]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
}
ProductContext.propTypes = {
  children: PropTypes.node,
  product: PropTypes.object,
  productIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};